import React from "react";
import { useLocalSearchParams, usePathname } from "expo-router";

import BusinessScreen from "@/components/business/BusinessScreen";
import PublicBusinessLoader from "@/components/business/PublicBusinessLoader";
import SeoHead from "@/components/seo/SeoHead";
import {
  getGeneratedPublicBusinessProfile,
  getGeneratedPublicBusinessProfileSlugs,
} from "@/lib/publicBusinessProfileSeo";
import { buildBusinessProfileSeo } from "@/lib/seo";

export function generateStaticParams() {
  return getGeneratedPublicBusinessProfileSlugs().map((slug) => ({ slug }));
}

function readSlugFromPath(pathname: string): string {
  const prefix = "/p/";

  if (!pathname.startsWith(prefix)) return "";

  const encodedSlug = pathname.slice(prefix.length).split("/")[0] || "";

  try {
    return decodeURIComponent(encodedSlug);
  } catch {
    return encodedSlug;
  }
}

export default function PublicBusinessPage() {
  const { slug } = useLocalSearchParams<{ slug?: string }>();
  const pathname = usePathname();
  const routeSlug = typeof slug === "string" ? slug : "";
  const pathSlug = React.useMemo(
    () => readSlugFromPath(pathname),
    [pathname]
  );
  const businessSlug = routeSlug || pathSlug;
  const staticBusiness = React.useMemo(
    () => getGeneratedPublicBusinessProfile(businessSlug),
    [businessSlug]
  );
  const staticSeo = React.useMemo(
    () =>
      staticBusiness
        ? buildBusinessProfileSeo(staticBusiness, businessSlug)
        : null,
    [businessSlug, staticBusiness]
  );

  return (
    <>
      {staticSeo ? <SeoHead {...staticSeo} /> : null}

      <PublicBusinessLoader slug={businessSlug}>
        {(business) => (
          <BusinessScreen
            business={business}
            currentSlug={businessSlug}
            renderSeo={!staticSeo}
          />
        )}
      </PublicBusinessLoader>
    </>
  );
}
